/* @flow */
'use strict';

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var uuid = require('uuid/v4');

var withIs = require('class-is');

var pathSepS = '/';
var pathSepB = Buffer.from(pathSepS);
var pathSep = pathSepB[0];
/**
 * A Key represents the unique identifier of an object.
 * Our Key scheme is inspired by file systems and Google App Engine key model.
 * Keys are meant to be unique across a system. Keys are hierarchical,
 * incorporating more and more specific namespaces. Thus keys can be deemed
 * 'children' or 'ancestors' of other keys:
 * - `new Key('/Comedy')`
 * - `new Key('/Comedy/MontyPython')`
 * Also, every namespace can be parametrized to embed relevant object
 * information. For example, the Key `name` (most specific namespace) could
 * include the object type:
 * - `new Key('/Comedy/MontyPython/Actor:JohnCleese')`
 * - `new Key('/Comedy/MontyPython/Sketch:CheeseShop')`
 * - `new Key('/Comedy/MontyPython/Sketch:CheeseShop/Character:Mousebender')`
 *
 */

var Key = /*#__PURE__*/function () {
  /* :: _buf: Buffer */
  function Key(s
  /* : string|Buffer */
  , clean
  /* : ?bool */
  ) {
    _classCallCheck(this, Key);

    if (typeof s === 'string') {
      this._buf = Buffer.from(s);
    } else if (Buffer.isBuffer(s)) {
      this._buf = s;
    }

    if (clean == null) {
      clean = true;
    }

    if (clean) {
      this.clean();
    }

    if (this._buf.length === 0 || this._buf[0] !== pathSep) {
      throw new Error("Invalid key: ".concat(this.toString()));
    }
  }
  /**
   * Convert to the string representation
   *
   * @param {string} [encoding='utf8']
   * @returns {string}
   */


  _createClass(Key, [{
    key: "toString",
    value: function toString(encoding
    /* : ?buffer$Encoding */
    )
    /* : string */
    {
      return this._buf.toString(encoding || 'utf8');
    }
    /**
     * Return the buffer representation of the key
     *
     * @returns {Buffer}
     */

  }, {
    key: "toBuffer",
    value: function toBuffer()
    /* : Buffer */
    {
      return this._buf;
    } // waiting on https://github.com/facebook/flow/issues/2286
    // $FlowFixMe

  }, {
    key: "clean",

    /**
     * Cleanup the current key
     *
     * @returns {void}
     */
    value: function clean() {
      if (!this._buf || this._buf.length === 0) {
        this._buf = Buffer.from(pathSepS);
      }

      if (this._buf[0] !== pathSep) {
        this._buf = Buffer.concat([pathSepB, this._buf]);
      } // normalize does not remove trailing slashes


      while (this._buf.length > 1 && this._buf[this._buf.length - 1] === pathSep) {
        this._buf = this._buf.slice(0, -1);
      }
    }
    /**
     * Check if the given key is sorted lower than ourself.
     *
     * @param {Key} key
     * @returns {bool}
     */

  }, {
    key: "less",
    value: function less(key
    /* : Key */
    )
    /* : bool */
    {
      var list1 = this.list();
      var list2 = key.list();

      for (var i = 0; i < list1.length; i++) {
        if (list2.length < i + 1) {
          return false;
        }

        var c1 = list1[i];
        var c2 = list2[i];

        if (c1 < c2) {
          return true;
        } else if (c1 > c2) {
          return false;
        }
      }

      return list1.length < list2.length;
    }
    /**
     * Returns the key with all parts in reversed order.
     *
     * @returns {Key}
     *
     * @example
     * new Key('/Comedy/MontyPython/Actor:JohnCleese').reverse()
     * // => Key('/Actor:JohnCleese/MontyPython/Comedy')
     */

  }, {
    key: "reverse",
    value: function reverse()
    /* : Key */
    {
      return Key.withNamespaces(this.list().slice().reverse());
    }
    /**
     * Returns the `namespaces` making up this Key.
     *
     * @returns {Array<string>}
     */

  }, {
    key: "namespaces",
    value: function namespaces()
    /* : Array<string> */
    {
      return this.list();
    }
    /** Returns the "base" namespace of this key.
     *
     * @returns {string}
     *
     * @example
     * new Key('/Comedy/MontyPython/Actor:JohnCleese').baseNamespace()
     * // => 'Actor:JohnCleese'
     *
     */

  }, {
    key: "baseNamespace",
    value: function baseNamespace()
    /* : string */
    {
      var ns = this.namespaces();
      return ns[ns.length - 1];
    }
    /**
     * Returns the `list` representation of this key.
     *
     * @returns {Array<string>}
     *
     * @example
     * new Key('/Comedy/MontyPython/Actor:JohnCleese').list()
     * // => ['Comedy', 'MontyPythong', 'Actor:JohnCleese']
     *
     */

  }, {
    key: "list",
    value: function list()
    /* : Array<string> */
    {
      return this.toString().split(pathSepS).slice(1);
    }
    /**
     * Returns the "type" of this key (value of last namespace).
     *
     * @returns {string}
     *
     * @example
     * new Key('/Comedy/MontyPython/Actor:JohnCleese').type()
     * // => 'Actor'
     *
     */

  }, {
    key: "type",
    value: function type()
    /* : string */
    {
      return namespaceType(this.baseNamespace());
    }
    /**
     * Returns the "name" of this key (field of last namespace).
     *
     * @returns {string}
     *
     * @example
     * new Key('/Comedy/MontyPython/Actor:JohnCleese').name()
     * // => 'JohnCleese'
     */

  }, {
    key: "name",
    value: function name()
    /* : string */
    {
      return namespaceValue(this.baseNamespace());
    }
    /**
     * Returns an "instance" of this type key (appends value to namespace).
     *
     * @param {string} s
     * @returns {Key}
     *
     * @example
     * new Key('/Comedy/MontyPython/Actor').instance('JohnClesse')
     * // => Key('/Comedy/MontyPython/Actor:JohnCleese')
     */

  }, {
    key: "instance",
    value: function instance(s
    /* : string */
    )
    /* : Key */
    {
      return new _Key(this.toString() + ':' + s);
    }
    /**
     * Returns the "path" of this key (parent + type).
     *
     * @returns {Key}
     *
     * @example
     * new Key('/Comedy/MontyPython/Actor:JohnCleese').path()
     * // => Key('/Comedy/MontyPython/Actor')
     *
     */

  }, {
    key: "path",
    value: function path()
    /* : Key */
    {
      var p = this.parent().toString();

      if (!p.endsWith(pathSepS)) {
        p += pathSepS;
      }

      p += this.type();
      return new _Key(p);
    }
    /**
     * Returns the `parent` Key of this Key.
     *
     * @returns {Key}
     *
     * @example
     * new Key("/Comedy/MontyPython/Actor:JohnCleese").parent()
     * // => Key("/Comedy/MontyPython")
     *
     */

  }, {
    key: "parent",
    value: function parent()
    /* : Key */
    {
      var list = this.list();

      if (list.length === 1) {
        return new _Key(pathSepS);
      }

      return new _Key(list.slice(0, -1).join(pathSepS));
    }
    /**
     * Returns the `child` Key of this Key.
     *
     * @param {Key} key
     * @returns {Key}
     *
     * @example
     * new Key('/Comedy/MontyPython').child(new Key('Actor:JohnCleese'))
     * // => Key('/Comedy/MontyPython/Actor:JohnCleese')
     *
     */

  }, {
    key: "child",
    value: function child(key
    /* : Key */
    )
    /* : Key */
    {
      if (this.toString() === pathSepS) {
        return key;
      } else if (key.toString() === pathSepS) {
        return this;
      }

      return new _Key(this.toString() + key.toString(), false);
    }
    /**
     * Returns whether this key is a prefix of `other`
     *
     * @param {Key} other
     * @returns {bool}
     *
     * @example
     * new Key('/Comedy').isAncestorOf('/Comedy/MontyPython')
     * // => true
     *
     */

  }, {
    key: "isAncestorOf",
    value: function isAncestorOf(other
    /* : Key */
    )
    /* : bool */
    {
      if (other.toString() === this.toString()) {
        return false;
      }

      return other.toString().startsWith(this.toString());
    }
    /**
     * Returns whether this key is a contains another as prefix.
     *
     * @param {Key} other
     * @returns {bool}
     *
     * @example
     * new Key('/Comedy/MontyPython').isDecendantOf('/Comedy')
     * // => true
     *
     */

  }, {
    key: "isDecendantOf",
    value: function isDecendantOf(other
    /* : Key */
    )
    /* : bool */
    {
      if (other.toString() === this.toString()) {
        return false;
      }

      return this.toString().startsWith(other.toString());
    }
    /**
     * Returns wether this key has only one namespace.
     *
     * @returns {bool}
     *
     */

  }, {
    key: "isTopLevel",
    value: function isTopLevel()
    /* : bool */
    {
      return this.list().length === 1;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get()
    /* : string */
    {
      return "[Key ".concat(this.toString(), "]");
    }
    /**
     * Constructs a key out of a namespace array.
     *
     * @param {Array<string>} list
     * @returns {Key}
     *
     * @example
     * Key.withNamespaces(['one', 'two'])
     * // => Key('/one/two')
     *
     */

  }], [{
    key: "withNamespaces",
    value: function withNamespaces(list
    /* : Array<string> */
    )
    /* : Key */
    {
      return new _Key(list.join(pathSepS));
    }
    /**
     * Returns a randomly (uuid) generated key.
     *
     * @returns {Key}
     *
     * @example
     * Key.random()
     * // => Key('/f98719ea086343f7b71f32ea9d9d521d')
     *
     */

  }, {
    key: "random",
    value: function random()
    /* : Key */
    {
      return new _Key(uuid().replace(/-/g, ''));
    }
  }]);

  return Key;
}();
/**
 * The first component of a namespace. `foo` in `foo:bar`
 *
 * @param {string} ns
 * @returns {string}
 */


function namespaceType(ns
/* : string */
)
/* : string */
{
  var parts = ns.split(':');

  if (parts.length < 2) {
    return '';
  }

  return parts.slice(0, -1).join(':');
}
/**
 * The last component of a namespace, `baz` in `foo:bar:baz`.
 *
 * @param {string} ns
 * @returns {string}
 */


function namespaceValue(ns
/* : string */
)
/* : string */
{
  var parts = ns.split(':');
  return parts[parts.length - 1];
}

var _Key = withIs(Key, {
  className: 'Key',
  symbolName: '@ipfs/interface-datastore/key'
});

module.exports = _Key;